import { ChevronRight } from 'lucide-react';
import { PageHeader } from '../components/ui/PageHeader';
import { moreMenuItemsByRole } from './roleTabs';

export function MoreMenu({ role, labels, onSelect }) {
  const items = moreMenuItemsByRole[role] || [];

  return (
    <div className="space-y-4">
      <PageHeader title={labels.more} subtitle={labels.moreMenuSubtitle} />
      <ul className="space-y-2">
        {items.map(({ id, labelKey, descKey, icon: Icon }) => (
          <li key={id}>
            <button
              type="button"
              onClick={() => onSelect(id)}
              className="flex w-full items-center gap-4 rounded-xl border border-border bg-card px-4 py-4 text-left shadow-card transition-colors hover:bg-surface active:bg-surface"
            >
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-light text-primary">
                <Icon className="h-5 w-5" />
              </span>
              <span className="min-w-0 flex-1">
                <span className="label-wrap block font-medium text-text">{labels[labelKey] || id}</span>
                {descKey && (
                  <span className="label-wrap block text-sm text-muted mt-0.5">{labels[descKey]}</span>
                )}
              </span>
              <ChevronRight className="h-5 w-5 shrink-0 text-muted" />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
